import { Link, useSearchParams } from "react-router-dom";
import { ArrowRight, MapPin, ListChecks } from "lucide-react";
import { LandRatingCard, SAMPLE_RATING } from "../components/LandRatingCard";
import { CTABand } from "./Home";

export default function RatingPage() {
  const [params] = useSearchParams();
  const q = (params.get("q") || "").trim();

  return (
    <div data-testid="rating-page">
      <section className="py-20 md:py-28 bg-white">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          {q && (
            <div className="flex items-center gap-2 mb-8" data-testid="rating-search-query">
              <MapPin size={16} strokeWidth={1.5} className="text-[#C1A74A]" />
              <p className="text-sm text-gray-500 font-light">Showing a sample rating for: <span className="font-medium text-[#113835]">{q}</span></p>
            </div>
          )}
          <div className="grid lg:grid-cols-2 gap-14 items-start">
            <div>
              <p className="tt-eyebrow mb-4">Here's What You'll Receive</p>
              <h1 className="font-heading text-3xl md:text-5xl font-medium text-[#113835] tracking-tight">
                This plot hasn't been rated yet — but it can be.
              </h1>
              <p className="mt-6 text-base text-gray-600 font-light leading-relaxed">
                The card beside is a <strong>sample</strong> Terraa Land Rating. To get the real, expert-verified rating for
                {q ? <span className="font-medium text-[#113835]"> "{q}"</span> : " your plot"}, submit a property verification request.
                Our legal team verifies every record at the source — government portals, sub-registrar offices, and village records.
              </p>
              <ul className="mt-8 space-y-3 text-sm text-gray-600 font-light">
                <li className="flex gap-3"><span className="text-[#C1A74A] font-heading">01</span> Title history traced across 30 years of records</li>
                <li className="flex gap-3"><span className="text-[#C1A74A] font-heading">02</span> Encumbrance, zoning & tax compliance checks</li>
                <li className="flex gap-3"><span className="text-[#C1A74A] font-heading">03</span> Deal-breaker alerts if the Mother Deed or EC is missing</li>
                <li className="flex gap-3"><span className="text-[#C1A74A] font-heading">04</span> Downloadable expert-verified PDF report</li>
              </ul>
              <div className="mt-10 flex flex-col sm:flex-row gap-4">
                <Link
                  to={`/request-title-search${q ? `?address=${encodeURIComponent(q)}` : ""}`}
                  data-testid="rating-request-cta"
                  className="tt-btn-gold"
                >
                  Get This Plot Rated <ArrowRight size={15} strokeWidth={1.5} />
                </Link>
                <Link to="/due-diligence-tracker" data-testid="rating-tracker-link" className="tt-btn-outline">
                  <ListChecks size={15} strokeWidth={1.5} /> DIY 10-Point Tracker
                </Link>
              </div>
            </div>
            <div className="pt-4">
              <LandRatingCard rating={{ ...SAMPLE_RATING, property_label: q || SAMPLE_RATING.property_label }} sample />
            </div>
          </div>
        </div>
      </section>
      <CTABand />
    </div>
  );
}
